// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1___540b0dd02e4dbe96d07","cls2":"CitationModal-cls2___134f3b09e45a8b6a338 CitationModal-cls1___540b0dd02e4dbe96d07"};